import React, { useState } from 'react';
import {
  Button,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { removePurchaseRebateSupplier } from '../../actions/supplierActions';
import moment from 'moment';

const RebateSupplierRow = ({ prsuppliers }) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [itemId, setItemId] = useState(0);

  if (!prsuppliers) return null;

  const toggleModal = () => setModal(!modal);

  const onDeleteButtonClick = (id) => {
    setItemId(id);
    toggleModal();
  };

  const removeEntry = () => {
    dispatch(removePurchaseRebateSupplier(itemId));
    toggleModal();
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Ampol says</ModalHeader>
        <ModalBody>Are you sure you would like to remove this entry?</ModalBody>
        <ModalFooter>
          <Button color='primary' onClick={removeEntry}>
            Yes
          </Button>{' '}
          <Button color='secondary' onClick={toggleModal}>
            No
          </Button>
        </ModalFooter>
      </Modal>
      <Row key={prsuppliers.supplierId}>
        <Col md='1' className='white-border'>
          {prsuppliers.supplierId}
        </Col>
        <Col md='5' className='white-border'>
          {prsuppliers.name}
        </Col>
        <Col md='3' className='white-border'>
          {moment(prsuppliers.createdOn).format('DD-MMM-YYYY')}
        </Col>
        <Col md='3' className='white-border'>
          <Button onClick={() => onDeleteButtonClick(prsuppliers.id)}>
            Delete
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default RebateSupplierRow;
